import { authHeader } from '@/_helpers';
export const workspaceService = {
    getWorkspaceAdmins,
    getWorkspaceDomains,
    getWorkspaceDomainByUser,
    getWorkspaceUsers,
    getWorkspaceUsersDomain,
    getWorkspaceDomainsByClient,
    getWorkspaceUsersByClient,
    getDomainsToBuy,
    updateWorkspaceToken,
    getFreeDomainsByClient,
    deleteDomains,
    buyNow,
    reUseDomain,
    addEmail,
    addDomain,
    getHttps,
    getProspectingDomainsDns,
    buyNowZapmail,
    getZapmailVerification,
    getZapmailUsers,
    getZapmailDomains,
    zapmailReUseDomain,
    getFreeZapmailDomainsByClient,
    getAdminDetails,
    getUserZapmailDetails,
    getOtherWorkspaces,
    retryZapmailDomainCreation,
    abandonZapmailDomainCreation,
    deleteZapmailMailbox,
};

const apiUrl = process.env.VUE_APP_ROOT_API;


function getWorkspaceAdmins() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-admins`, requestOptions).then(handleResponse);
}

function getOtherWorkspaces() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-other-workspaces`, requestOptions).then(handleResponse);
}

function getWorkspaceDomains(workspace_id = '', condition = '', count = '', zapmail_id = '') {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
  return fetch(`${apiUrl}/workspace/get-workspace-domains?workspace_id=${workspace_id}&condition=${condition}&count=${count}&zapmail_id=${zapmail_id}`, requestOptions)
            .then(handleResponse);
}


function addEmail(user_id,data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ user_id,data })
    };
    return fetch(`${apiUrl}/workspace/add-email`, requestOptions).then(handleResponse);

}

function getHttps(domain) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ domain })
    };
    return fetch(`${apiUrl}/workspace/https`, requestOptions).then(handleResponse);

}

function getProspectingDomainsDns() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-prospecting-domains-dns`, requestOptions)
        .then(handleResponse);
}

function deleteDomains(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ data })
    };
    return fetch(`${apiUrl}/workspace/delete-domains`, requestOptions).then(handleResponse);
}

function addDomain(sales_representative_id,data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ sales_representative_id,data })
    };
    return fetch(`${apiUrl}/workspace/add-domain`, requestOptions).then(handleResponse);

}

function getWorkspaceDomainByUser(user_id){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ user_id })
    };
    return fetch(`${apiUrl}/workspace/get-workspace-domain-user`, requestOptions)
        .then(handleResponse);
}

function getWorkspaceUsers(workspace_id) {

    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-users/${workspace_id}`, requestOptions).then(handleResponse);
}

function getWorkspaceUsersDomain(workspace_domain_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/workspace/get-workspace-users-domain/${workspace_domain_id}`, requestOptions).then(handleResponse);
}

function updateWorkspaceToken(code) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ code })
    };
    return fetch(`${apiUrl}/workspace/update-code`, requestOptions)
        .then(handleResponse);
}

function getWorkspaceDomainsByClient(clientid) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ clientid })
    };
    return fetch(`${apiUrl}/workspace/get-domains-by-client`, requestOptions)
        .then(handleResponse);
}

function getFreeDomainsByClient(client_id, complete = false, count = false) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id, complete, count})
    };
    return fetch(`${apiUrl}/workspace/get-free-domains`, requestOptions)
        .then(handleResponse);
}

function getWorkspaceUsersByClient(clientid) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ clientid })
    };
    return fetch(`${apiUrl}/workspace/get-users-by-client`, requestOptions)
        .then(handleResponse);
}

function getDomainsToBuy(count = null) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({count})
    };
    return fetch(`${apiUrl}/workspace/get-domains-to-buy`, requestOptions)
        .then(handleResponse);
}

function reUseDomain(buy,domain,project) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({buy,domain,project})
    };
    return fetch(`${apiUrl}/workspace/reuse-domain`, requestOptions)
        .then(handleResponse);
}

function buyNow(buy,domain,project) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({buy,domain,project})
    };
    return fetch(`${apiUrl}/workspace/buy-now`, requestOptions)
        .then(handleResponse);
}

function buyNowZapmail(buy, domain, zapmail_id){
        const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ buy, domain, zapmail_id })
    };
    return fetch(`${apiUrl}/zapmail/buy-now`, requestOptions)
        .then(handleResponse);
}

function getZapmailVerification(email){
        const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/zapmail/get-auth-code/${email}`, requestOptions).then(handleResponse);
}

function getZapmailUsers(zapmail_id){
        const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/zapmail/get-workspace-users/${zapmail_id}`, requestOptions).then(handleResponse);
}

function getZapmailDomains(zapmail_id = '', condition = '', count = '') {
        const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/zapmail/get-workspace-domains?zapmail_id=${zapmail_id}&condition=${condition}&count=${count}`, requestOptions).then(handleResponse);
}

function zapmailReUseDomain(buy,domain,zapmail_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({buy,domain,zapmail_id})
    };
    return fetch(`${apiUrl}/zapmail/reuse-domain`, requestOptions)
        .then(handleResponse);
}

function getFreeZapmailDomainsByClient(client_id, complete = false, count = false){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id, complete, count})
    };
    return fetch(`${apiUrl}/zapmail/get-free-domains`, requestOptions)
        .then(handleResponse);
}

function getAdminDetails(email){
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/zapmail/get-auth-code/${email}/admin`, requestOptions).then(handleResponse);
}

function getUserZapmailDetails(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/zapmail/user-details`, requestOptions).then(handleResponse);
}

function retryZapmailDomainCreation(domain) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ domain }),
    };
    return fetch(`${apiUrl}/zapmail/retry-domain-creation`, requestOptions).then(handleResponse);
}

function abandonZapmailDomainCreation(domain) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ domain }),
    };
    return fetch(`${apiUrl}/zapmail/abandon-domain-creation`, requestOptions).then(handleResponse);
}

function deleteZapmailMailbox(user_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ user_id }),
    };
    return fetch(`${apiUrl}/zapmail/delete-mailbox`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
